import { setEmpresaAction } from './empresaActions';
import { useDispatch, useSelector } from 'react-redux';
import Empresa from '../../shared/entity/Empresa';
import { RootAppState } from '../store';

export const useEmpresa = (): [Empresa, (emp: Empresa) => void] => {
  const empresa = useSelector<RootAppState>((state) => state.empresa) as Empresa;
  const dispatch = useDispatch();
  const setEmpresa = (emp: Empresa) => {
    const action = setEmpresaAction(emp);
    dispatch(action);
  };
  return [empresa, setEmpresa];
};
